import { createSlice } from '@reduxjs/toolkit';
import { findLocationManagement, createLocationManagement, getLocationManagement } from './api';
import { initialState } from './api/interface';

const locationManagementSlice = createSlice({
  name: 'locationManagement',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findLocationManagement.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findLocationManagement.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findLocationManagement.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(createLocationManagement.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createLocationManagement.fulfilled, (state, action) => {
      state.data.push(action.payload);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(createLocationManagement.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
    builder.addCase(getLocationManagement.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getLocationManagement.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getLocationManagement.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = locationManagementSlice.actions;
export default locationManagementSlice.reducer;
